import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from "react-intl";

class Description extends Component {
  constructor (props) {
    super(props);

    this.state = {
      truncDesc: true
    };

    this.toggleDesc = this.toggleDesc.bind(this);
  }

  toggleDesc () {
    this.setState({ truncDesc: !this.state.truncDesc });
  }

  render () {
    const { description, moreLink, intl } = this.props;

    if (description && moreLink) {
      return (
        <div className="description-wrapper">
          <div className="description">{ description }{ moreLink && <span className="more-link">&nbsp;<FormattedMessage id="shared_components.description.more_text" defaultMessage="more" /></span> }</div>
        </div>
      )
    }

    const { truncDesc } = this.state;
    const descClass = truncDesc ? 'trunc' : '';
    const toggleBtn = (btnText) => {
      return <button className="toggle-listing-desc btn-link" onClick={this.toggleDesc}>{btnText}</button>;
    };

    const readMoreBtn = (
      <div className="button-with-fade">
        {toggleBtn(intl.formatMessage({ id: 'shared_components.listing_description.read_more_btn', defaultMessage: 'Read More' }))}
      </div>
    );

    const button = truncDesc ? readMoreBtn : toggleBtn(intl.formatMessage({ id: 'shared_components.listing_description.hide_btn', defaultMessage: 'Hide' }));

    if (description) {
      return (
        <div className={`desc-wrapper ${descClass}`}>
          <p className={`description ${descClass}`}>{description}</p>
          {button}
        </div>
      );
    }
    return null;
  }
}

export default injectIntl(Description);
